import { UsersRound } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { toneSoftClass } from './tone'

export function ConfiguredLimitBadge({ label, className }: { label: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex min-h-7 items-center gap-1.5 rounded-pill border px-2.5 text-xs font-medium',
        toneSoftClass.brand,
        className,
      )}
    >
      <UsersRound className="size-3.5 shrink-0" aria-hidden />
      <span className="truncate">{label}</span>
    </span>
  )
}
